/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { Api } from 'app/shared/lib/api/api';
import { IApiQueryResults, IApiActionResults, IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import * as Core from 'app/core/models/essette-api';


export interface IEmailSearchFilters {
    usersOnly?: boolean | null;
}
@autoinject
export class EmailService {

    constructor(private readonly api: Api, private readonly logger: AppLogger) {
        this.logger.source = this;
    }

    ////****************** Queries **************************************************////

    public async loadEmailRecipientsByEmailTemplate(emailTemplateId: string, options?: Partial<IQueryLoadOptions>, includes: string[] = [], searchFilters?: IEmailSearchFilters, fields: string[] = []):
        Promise<IApiQueryResults<Core.EmailTemplateRecipient>> {
        const query = this.api
            .query(`email/templates/${emailTemplateId}/recipients`)
            .applyStandardLoadOptions(options)
            .include(...includes)
            .field(...fields);

        if(searchFilters?.usersOnly) {
            query.filterIsNull('user.id', false);
        }

        return await this.api.get(query);
    }

    ////****************** Actions **************************************************////

    public async updateEmailTemplateRecipient(recipient: Core.EmailTemplateRecipient): Promise<IApiActionResults> {
        const action = this.api.action('update', `email/templates/recipients/${recipient.id}`, recipient);

        return await this.api.post(action);
    }

    public async insertEmailTemplateRecipient(recipient: Core.EmailTemplateRecipient): Promise<IApiActionResults> {
        const action = this.api.action('insert', `email/templates/recipients`, recipient);

        return await this.api.post(action);
    }

    public async activateEmailTemplateRecipient(recipientId: string, isActive: boolean): Promise<IApiActionResults> {
        const actionCode = isActive ? 'reactivate' : 'deactivate';
        const action = this.api.action(actionCode, `email/templates/recipients/${recipientId}`, { isActive: isActive });

        if(isActive) {
            return await this.api.post(action);
        } else {
            return await this.api.delete(action);
        }
    }

}
